export const CLOUD_WORKSPACE_CHANGED_BROADCAST_CHANNEL_KEY =
  'affine-cloud-workspace-changed';
